export default __webpack_public_path__ + "1c158bb34c8abd9ca196eb161decb762.png";